// This file should only contain action type constants.
export const SET_WIS_INCENTIVES = 'SET_WIS_INCENTIVES';
export const SET_WIS_VEHICLE = 'SET_WIS_VEHICLE';
export const VCDA_ERROR = 'VCDA_ERROR';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';
